/* ==========================================================================
   SERPROMAQ - CONFIGURACIÓN E INICIALIZACIÓN DE FIREBASE SDK
   ========================================================================== */

import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';
import { 
  getFirestore, 
  collection, 
  doc, 
  getDocs, 
  getDoc,
  setDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  onSnapshot, 
  query, 
  orderBy, 
  serverTimestamp 
} from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export const firebaseConfig = {
  apiKey: "AIzaSyCBPh96ncCKSyXyXcXZnnrj0j_aVx_FWpI",
  authDomain: "serpromaq-web.firebaseapp.com",
  projectId: "serpromaq-web",
  storageBucket: "serpromaq-web.firebasestorage.app",
  messagingSenderId: "139767510222",
  appId: "1:139767510222:web:11e5f236640878f8458c9f"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Servicios de Firebase
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  collection,
  doc,
  getDocs,
  getDoc,
  setDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  query,
  orderBy,
  serverTimestamp,
  ref,
  uploadBytes,
  getDownloadURL
};
